import _ from 'lodash'
import React, {Component} from 'react';
import {Checkbox, Menu, Table, Label} from 'semantic-ui-react';

class Designations extends Component {

  /***** Page Functions *****/

  constructor(props) {
    super(props);
    var lm_type = 0
    if (this.props.lmType)
      lm_type = parseInt(this.props.lmType, 10)
    this.state = {
      incl_Submitted: false,
      column: null,
      direction: null,
      lm_type: lm_type,
      designationTypes: {},
      results: []
    };
    // this.handleRowClick = this.handleRowClick.bind(this);
  }

  componentDidMount() {
    this.startUpdatingResults();
    this.startUpdatingDesignationTypes();
  }

  render() {
    return (
      <div className="Designations">
        {this.renderTableHeader()}
        {this.renderResults()}
      </div>
    )
  }

  /***** Supporting Functions *****/

  /********************************/
  /* Landmark Types               */
  /********************************/

  /***** Renderer ****/
  renderLMtypes() {
    var designationTypes = this.state.designationTypes
    var retval = []
    retval.push(
      <Menu.Item key="0" as="a">
        <Checkbox name='lmTypes' radio value={0} style={{"fontSize" : "small"}}
                  checked={this.state.lm_type === 0} label='All'
                  onChange={this.handleLmTypeChange}/>
      </Menu.Item>
    )
    for (var i = 0; i < designationTypes.length; i++) {
      retval.push(<Menu.Item key={i+1} as="a">
        <Checkbox name='lmTypes' radio value={i+1}
                  checked={this.state.lm_type === i+1}
                  onChange={this.handleLmTypeChange}/>
        <Label>{designationTypes[i]["LM_TYPE"]}<Label.Detail>{designationTypes[i]["NUM_DESIGNATIONS"]}</Label.Detail></Label>
      </Menu.Item>)
    }
    return (<Menu compact>{retval}</Menu>)
  }

  /***** Event Handlers *****/
  handleLmTypeChange = (e, data) => {
    this.setState({lm_type: data.value}, () => {
      this.startUpdatingResults()
    })
  }

  /***** Data Handling ****/
  startUpdatingDesignationTypes() {
    var url = window.globalAppTrackURL + "LPsummary";
    if (this.state.incl_Submitted)
      url += "/0";
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.finishUpdatingDesignationTypes(json)
      );
  }

  finishUpdatingDesignationTypes(json) {
    this.setState({designationTypes: json});
  }

  /********************************/
  /* Table Header                 */
  /********************************/

  /***** Renderer *****/
  renderTableHeader() {
    return (
      <table width="100%"><tbody>
        <tr>
          <td>
            <h3>Select designation to create DOF Cover Letter: </h3>

          </td>
          <td align="right">
            &nbsp;
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            {this.renderLMtypes()}
          </td>
        </tr>
      </tbody></table>
    )
  }

// <Checkbox slider fitted style={{"fontSize" : "small"}}
// label="Include submitted"
// onChange={this.handleInclSubmitted}
// checked={this.state.incl_Submitted}/>

  /***** Event Handler *****/
  handleInclSubmitted = (e, data) => {
    this.setState({incl_Submitted: data.checked}, () => {
        this.startUpdatingResults()
        this.startUpdatingDesignationTypes()
      }
    )
  }

  /********************************/
  /* Results                      */
  /********************************/

  /***** Renderer ****/
  renderResults() {
    //var results = this.state.results
    const { column, results, direction } = this.state
    var retval = []
    var lmTypeColumm
    
    for (var i = 0; i < results.length; i++) {
      const lpNumber = results[i]["LP_NUMBER"]
      if (this.state.lm_type === 0)
        lmTypeColumm = [<Table.Cell style={{"whiteSpace" : "nowrap"}}>{results[i]["LM_TYPE"]}</Table.Cell>]
      else
        lmTypeColumm = []
      if (new Date(results[i]["DESIG_PLUS_130"]) < new Date())
        retval.push(
          <Table.Row key={i} onClick={this.handleRowClick.bind(this, lpNumber)} style={{cursor: "pointer", color:"green"}}>
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{lpNumber}</Table.Cell>
            <Table.Cell>{results[i]["LM_NAME"]}</Table.Cell>
            {lmTypeColumm}
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{results[i]["DESIG_DATE_STR"]}</Table.Cell>
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{results[i]["DESIG_DATE_130_STR"]}</Table.Cell>
          </Table.Row>
        )
      else
        retval.push(
          <Table.Row key={i} style={{color:"red"}}>
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{lpNumber}</Table.Cell>
            <Table.Cell>{results[i]["LM_NAME"]}</Table.Cell>
            {lmTypeColumm}
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{results[i]["DESIG_DATE_STR"]}</Table.Cell>
            <Table.Cell style={{"whiteSpace" : "nowrap"}}>{results[i]["DESIG_DATE_130_STR"]}</Table.Cell>
          </Table.Row>
        )
    }

    if (this.state.lm_type === 0)
      lmTypeColumm = [<Table.HeaderCell>Landmark Type</Table.HeaderCell>]
    else
      lmTypeColumm = []
    return (
      <div className="designations-list">
        <Table sortable celled selectable striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'LP_NUMBER' ? direction : null}
                                onClick={this.handleSort('LP_NUMBER')} >LP Number</Table.HeaderCell>
              <Table.HeaderCell sorted={column === 'LM_NAME' ? direction : null}
                                onClick={this.handleSort('LM_NAME')} >Landmark Name</Table.HeaderCell>
              {lmTypeColumm}
              <Table.HeaderCell sorted={column === 'DESIG_DATE' ? direction : null}
                                onClick={this.handleSort('DESIG_DATE')}>Date of Designation</Table.HeaderCell>
              <Table.HeaderCell>130 day flag</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {retval}
          </Table.Body>
        </Table>
      </div>
    )
  }

  /***** Event Handler ****/
  handleSort = (clickedColumn) => () => {
    const { column, results, direction } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        results: _.sortBy(results, [clickedColumn]),
        direction: 'ascending',
      })

      return
    }

    this.setState({
      results: results.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleRowClick(lpNumber) {
    this.props.handleDesignationClick(this.state.lm_type, lpNumber);
  }

  handleDesignatedSites(filterName, filters) {
    this.startUpdatingResults();
    this.setState({showDesignatedSites: true});
  }

  /***** Data Handling ****/
  startUpdatingResults() {
    var url = window.globalAppTrackURL + "LPs";
    url += "/" + (this.state.incl_Submitted ? 1 : 0) + this.state.lm_type;
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.finishUpdatingResults(json)
      );
  }

  finishUpdatingResults(json) {
    this.setState({results: json});
  }

}

export default Designations




// WEBPACK FOOTER //
// ./src/components/Designations.js